/// <amd-module name="SuiteCommerce.SizeChart.PDP"/>
define("SuiteCommerce.SizeChart.PDP", ["require", "exports", "SuiteCommerce.SizeChart.PDP.View"], function (require, exports, PDP_View_1) {
    "use strict";
    return {
        mountToApp: function (options) {
            var pdp = options.container.getComponent('PDP');
            if (pdp) {
                this.addViews(pdp, options.router);
            }
        },
        addViews: function (pdp, router) {
            var childViewConstructor = {
                'Product.Options': {
                    'SizeChart.Link': {
                        childViewConstructor: function () {
                            return new PDP_View_1.PDPView({
                                pdp: pdp,
                                router: router,
                            });
                        },
                    },
                },
            };
            pdp.addChildViews(pdp.PDP_FULL_VIEW, childViewConstructor);
            pdp.addChildViews(pdp.PDP_QUICK_VIEW, childViewConstructor);
        },
    };
});
